<template>
  <div
    :data-tint="type"
    class="bg-primary-200 border-primary-300 dark:bg-primary-800/10 dark:border-primary-900 relative overflow-hidden rounded-lg border text-gray-800 dark:text-white"
    role="alert"
    tabindex="-1"
    :class="{
      'p-4': !compact,
      'p-3': compact
    }"
  >
    <div
      v-if="bigIcon"
      class="absolute opacity-10"
      :class="{
        '-top-5 -right-10 text-8xl': !compact,
        '-top-2 -right-6 text-7xl': compact
      }"
    >
      <FontAwesomeIcon :icon="icon" />
    </div>
    <div class="flex">
      <div v-if="!bigIcon" class="shrink-0">
        <FontAwesomeIcon :icon="icon" />
      </div>
      <div
        class="ms-3 flex flex-col"
        :class="{
          'gap-2': !compact,
          'gap-1': compact
        }"
      >
        <h3 v-if="title?.length" class="font-semibold">
          {{ title }}
        </h3>
        <div
          v-if="description?.length"
          class="text-sm font-semibold text-gray-600 dark:text-neutral-400"
          v-html="description"
        ></div>
        <slot />
        <div v-if="actions?.length">
          <div class="flex gap-x-3">
            <button
              v-for="action in actions"
              :key="action.id"
              type="button"
              class="text-primary-700 hover:text-primary-900 focus:text-primary-900 dark:text-primary-500 dark:hover:text-primary-400 dark:focus:text-primary-400 inline-flex items-center gap-x-2 rounded-lg border border-transparent text-sm font-semibold focus:outline-none disabled:pointer-events-none disabled:opacity-50"
              @click="action.action"
            >
              {{ action.name }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'AlertPanel',
  components: { FontAwesomeIcon },
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: false,
      default: null
    },
    type: {
      type: String,
      required: false,
      default: 'info',
      validator: (val) => ['info', 'warning', 'danger', 'success'].includes(val)
    },
    actions: {
      type: Array,
      required: false,
      default: null
    },
    compact: {
      type: Boolean,
      required: false,
      default: false
    },
    bigIcon: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    icon() {
      switch (this.type) {
        case 'success':
          return ['fal', 'circle-check']
        case 'warning':
          return ['fal', 'exclamation-circle']
        case 'danger':
          return ['fal', 'exclamation-triangle']
        default:
          return ['fal', 'circle-info']
      }
    }
  }
}
</script>

<style scoped></style>
